<template>
    <div  class=" transition-all test flex flex-col fixed top-0 left-0 w-screen h-screen  items-center justify-center  z-50 bg-[#00000063] backdrop-blur-[2px]  text-lg  ">
        <div class=" max-lg:w-[90%] w-[500px]  2xl:w-[550px] rounded-lg bg-white z-50  py-5 px-4">
            <div  class=" flex flex-col items-center gap-3 py-5">
                <div class="rounded-full p-4 max-w-[100px] max-h-[100px] bg-yellow-100">
                    <div class="rounded-full p-3 flex items-center justify-center bg-yellow-500">
                        <div class="h-auto" id="pencil" style="width: 120px;">
                            <img src="./PromptSvg/papsi_info.f9d6d450.svg" class="m-0 p-0 block border-0">
                        </div>
                    </div>
                </div>
                <p class="font-bold text-2xl text-yellow-500">CONFIRMATION</p>
                <p class="text-gray-600 text-lg mx-7 justify-center text-center " name="error">{{ header }}</p>
            </div>
            <div class="flex items-center bg-white w-full pt-3">
                <div class="flex gap-4 w-full px-4">
                    <button class="p-3 rounded-lg font-semibold  uppercase text-xl h-12 bg-theme-primary cursor-pointer bg-white border-2 border-yellow-500 text-yellow-500 w-[50%] flex items-center justify-center hover:bg-yellow-100" @click="$emit('no')">NO</button>
                    <button class="p-3 rounded-lg font-semibold  uppercase text-xl h-12 bg-theme-primary cursor-pointer bg-yellow-500  text-white w-[50%] flex items-center justify-center hover:bg-yellow-400" @click="$emit('yes')">YES</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue"
export default defineComponent({
    props:{
        header:{
            type:    String,
            default: null,
        },
    }
})
</script>
